import { useEffect } from 'react'

import { shouldUseSegment } from './segment.utils'
import type { SegmentProperties } from './types/segmentProperties'

type UseAdminPageNavigationProps = {
  properties: Partial<SegmentProperties>
  analytics: SegmentAnalytics.AnalyticsJS
  event?: string
  enabled?: boolean
}

export const useAnalyticsPage = ({
  event,
  properties,
  enabled = true,
  analytics,
}: UseAdminPageNavigationProps): void => {
  useEffect(() => {
    if (enabled && shouldUseSegment(analytics)) {
      analytics.page(event, properties)
    }
  }, [enabled, event, properties, analytics])
}
